// extracted by mini-css-extract-plugin
export default {"dialog-no-cr-no-h":"no-cr-no-h-dialog_dialog-no-cr-no-h__iVMX9"};